// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpressSetupJsonExtendedDto } from './IExpressSetupJsonExtendedDto';
import {
    IExpressSetupJsonExtendedDtoFromJSON,
    IExpressSetupJsonExtendedDtoFromJSONTyped,
    IExpressSetupJsonExtendedDtoToJSON,
    IExpressSetupJsonExtendedDtoToJSONTyped,
} from './IExpressSetupJsonExtendedDto';
import type { IContactDto } from './IContactDto';
import {
    IContactDtoFromJSON,
    IContactDtoFromJSONTyped,
    IContactDtoToJSON,
    IContactDtoToJSONTyped,
} from './IContactDto';
import type { IExpressSetupLinkDto } from './IExpressSetupLinkDto';
import {
    IExpressSetupLinkDtoFromJSON,
    IExpressSetupLinkDtoFromJSONTyped,
    IExpressSetupLinkDtoToJSON,
    IExpressSetupLinkDtoToJSONTyped,
} from './IExpressSetupLinkDto';
import type { IAuditActor } from './IAuditActor';
import {
    IAuditActorFromJSON,
    IAuditActorFromJSONTyped,
    IAuditActorToJSON,
    IAuditActorToJSONTyped,
} from './IAuditActor';

/**
 * 
 * @export
 * @interface IExpressSetupExtendedDto
 */
export interface IExpressSetupExtendedDto {
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupExtendedDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupExtendedDto
     */
    org_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    org_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    organization_short_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    partner_name?: string;
    /**
     * 
     * @type {IExpressSetupLinkDto}
     * @memberof IExpressSetupExtendedDto
     */
    links?: IExpressSetupLinkDto;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupExtendedDto
     */
    contact_id?: number;
    /**
     * 
     * @type {Array<IContactDto>}
     * @memberof IExpressSetupExtendedDto
     */
    contacts?: Array<IContactDto>;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    status_type?: IExpressSetupExtendedDtoStatusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupExtendedDto
     */
    is_external_link?: boolean;
    /**
     * 
     * @type {IAuditActor}
     * @memberof IExpressSetupExtendedDto
     */
    audit_actor?: IAuditActor;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupExtendedDto
     */
    replenishment_day_number?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    replenishment_frequency_type?: IExpressSetupExtendedDtoReplenishmentFrequencyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupExtendedDto
     */
    prefund_replenishment_percent?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupExtendedDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupExtendedDto
     */
    number_of_days_before_plan_start?: number;
    /**
     * 
     * @type {IExpressSetupJsonExtendedDto}
     * @memberof IExpressSetupExtendedDto
     */
    json_record?: IExpressSetupJsonExtendedDto;
}

/**
* @export
* @enum {string}
*/
export enum IExpressSetupExtendedDtoStatusTypeEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    ABANDONED = 'ABANDONED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    ADVANCED_SETUP = 'ADVANCED_SETUP'
}
/**
* @export
* @enum {string}
*/
export enum IExpressSetupExtendedDtoReplenishmentFrequencyTypeEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}


/**
 * Check if a given object implements the IExpressSetupExtendedDto interface.
 */
export function instanceOfIExpressSetupExtendedDto(value: object): value is IExpressSetupExtendedDto {
    return true;
}

export function IExpressSetupExtendedDtoFromJSON(json: any): IExpressSetupExtendedDto {
    return IExpressSetupExtendedDtoFromJSONTyped(json, false);
}

export function IExpressSetupExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'organization_short_name': json['organization_short_name'] == null ? undefined : json['organization_short_name'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'links': json['links'] == null ? undefined : IExpressSetupLinkDtoFromJSON(json['links']),
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(IContactDtoFromJSON)),
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'is_external_link': json['is_external_link'] == null ? undefined : json['is_external_link'],
        'audit_actor': json['audit_actor'] == null ? undefined : IAuditActorFromJSON(json['audit_actor']),
        'replenishment_day_number': json['replenishment_day_number'] == null ? undefined : json['replenishment_day_number'],
        'replenishment_frequency_type': json['replenishment_frequency_type'] == null ? undefined : json['replenishment_frequency_type'],
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : json['prefund_replenishment_percent'],
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'number_of_days_before_plan_start': json['number_of_days_before_plan_start'] == null ? undefined : json['number_of_days_before_plan_start'],
        'json_record': json['json_record'] == null ? undefined : IExpressSetupJsonExtendedDtoFromJSON(json['json_record']),
    };
}

export function IExpressSetupExtendedDtoToJSON(json: any): IExpressSetupExtendedDto {
    return IExpressSetupExtendedDtoToJSONTyped(json, false);
}

export function IExpressSetupExtendedDtoToJSONTyped(value?: IExpressSetupExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'org_id': value['org_id'],
        'org_path': value['org_path'],
        'organization_name': value['organization_name'],
        'organization_short_name': value['organization_short_name'],
        'partner_name': value['partner_name'],
        'links': IExpressSetupLinkDtoToJSON(value['links']),
        'contact_id': value['contact_id'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(IContactDtoToJSON)),
        'status_type': value['status_type'],
        'is_external_link': value['is_external_link'],
        'audit_actor': IAuditActorToJSON(value['audit_actor']),
        'replenishment_day_number': value['replenishment_day_number'],
        'replenishment_frequency_type': value['replenishment_frequency_type'],
        'prefund_replenishment_percent': value['prefund_replenishment_percent'],
        'account_number_last4': value['account_number_last4'],
        'number_of_days_before_plan_start': value['number_of_days_before_plan_start'],
        'json_record': IExpressSetupJsonExtendedDtoToJSON(value['json_record']),
    };
}

